import React, { Component } from 'react';
import {createMarkup} from './Factory';
import {UISref} from 'ui-router-react'; 

class KalenderRow extends Component {
	
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);	
	}
	handleClick(){
		let {event_start_date,event_end_date,title,event_anmelden,event_perform,event_start_time} = this.props;
		let $date = event_start_date;
		if(event_end_date){
			$date += ` - ${event_end_date}`
		}
		let event_title = title.rendered;
		let $data = [event_title,$date,event_perform,event_anmelden,event_start_time];
		this.props.handleClick($data);
	}
	render() {		 
		const {slug,event_start_date,event_end_date,event_start_time,event_end_time,title,excerpt,associate_taxonomy,event_anmelden,admin_email} = this.props;
		const {label_anmelden,label_clock} = this.props.staticData;
		let $date = event_start_date;
		if(event_end_date){
			$date += ` - ${event_end_date}`
		}
		let $time = event_start_time;
		if(event_end_time){
			$time += ` - ${event_end_time}`
		}
		let $event_anmelden = '';
		if(event_anmelden==='1' || event_anmelden==='3'){
			$event_anmelden = 
				<a className="msg h2" onClick={this.handleClick}>
					{label_anmelden}
				</a>
		}
		if(event_anmelden==='2'){
			let $body = '';
			if(document.language==='en'){
				$body = `
								Dear TAXISPALAIS-Team,%0D%0A %0D%0A

								I would like to register for the following event:%0D%0A %0D%0A
								${$date}, ${title.rendered}.%0D%0A %0D%0A

								Best regards
							`;
			}else{ 
				$body = `
						Liebes Taxispalais-Team,%0D%0A %0D%0A

						hiermit möchte ich mich zur Veranstaltung ${title.rendered} am ${$date} anmelden.%0D%0A %0D%0A

						Mit freundlichen Grüßen
						`;
			}
			let $subject = `${$date} ${title.rendered}`;
			$event_anmelden = 
				<a className="msg h2" href={`mailto:${admin_email}?subject=${$subject}&body=${$body}`}>
					{label_anmelden}
				</a>
		}
		let $dash = '';
		if(excerpt.render==='')
			$dash = 'hide-dash';
		return(
			<div className="event-item clearfix">
				<div className="date">
					<div className="day h2">
						{$date}
					</div>
					<div className="hour sm-txt">
						{$time} {label_clock}
					</div>
				</div>
				
				<div className="title">
					<UISref to="root.programm.kalenderdetails" params={{item:slug}}>
						<a>
							<div className="h2" dangerouslySetInnerHTML={createMarkup(title.rendered)}></div>
						</a>
					</UISref>
					<div className="info sm-txt">
						
						{
							associate_taxonomy.map( (data,i)=>
								<span key={i} className={`event-cat ${$dash}`}>
									<UISref to="root.programm.kalender-kategorie.name" params={{item:data.slug}} >		
										<a>{data.name}</a>
									</UISref>	
								</span>
							)
						}
                        {
						(excerpt.rendered)?
						<span className="excerpt" dangerouslySetInnerHTML={createMarkup(excerpt.rendered)}></span>
                        :null
                        }
					</div>
                    {$event_anmelden}
				</div>
				{$event_anmelden}
			</div>
		) 
	}	
}
export default KalenderRow;




// WEBPACK FOOTER //
// ./src/components/KalenderRow.js